export const environment = {
  production: true,
  apiUrl: 'controller/',
  apiUrlPublic: 'public/',
};
